<script setup lang="ts">
import '@/assets/styles/career.css';
import {ref} from "vue";
import axios from 'axios';

const form = ref({
  name: "",
  forename: "",
  email: "",
  number: "",
  position: "Pflegefachkraft",
  resume: null as File | null,
  cover: null as File | null,
  data: false
});

const showForm = ref(false);
const showToast = ref(false);
const toastMessage = ref("");
const submitted = ref(false);
const error = ref('');
const showConfirmToast = ref(false);

// Datei hochladen
const handleFileUpload = (event: Event, type: "resume" | "cover") => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    form.value[type] = target.files[0];
  }
};

// Wird nur beim Klick auf „Bewerbung absenden“ ausgelöst → öffnet nur Dialog
const submitForm = async () => {
  showConfirmToast.value = true;
};

// Wenn Nutzer „Ja“ klickt → Formular wirklich senden
const confirmSubmission = async () => {
  showConfirmToast.value = false;
  error.value = '';

  try {
    const formData = new FormData();
    formData.append('name', form.value.name);
    formData.append('forename', form.value.forename);
    formData.append('email', form.value.email);
    formData.append('number', form.value.number);
    formData.append('position', form.value.position);

    if (form.value.resume) formData.append('resume', form.value.resume);
    if (form.value.cover) formData.append('cover', form.value.cover);

    const res = await axios.post("/api/application", formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    });

    submitted.value = true;
    toastMessage.value = "Ihre Bewerbung wurde übermittelt.";
    showToast.value = true;

    console.log("Antwort: ", res.data);

    setTimeout(() => showToast.value = false, 4000);
    resetForm();
    showForm.value = false;

  } catch (err) {
    error.value = 'Fehler beim Versenden';
    console.error(err);
  }
};

const cancelSubmission = () => {
  showConfirmToast.value = false;
};

const resetForm = () => {
  form.value = {
    name: "",
    forename: "",
    email: "",
    number: "",
    position: "Pflegefachkraft",
    resume: null,
    cover: null,
    data: false
  };
};

const openForm = (position: string) => {
  form.value.position = position.toLowerCase().replace(/\s/g, '-');
  showForm.value = true;
};

const closeForm = () => {
  showForm.value = false;
};
</script>

<template>
  <div class="career">
    <!-- Eigenes Toast -->
    <div v-if="showToast" class="toast">
      {{ toastMessage }}
    </div>
    <!-- Bestätigungs-Toast -->
    <div v-if="showConfirmToast" class="confirm-toast-overlay">
      <div class="confirm-toast-box">
        <p>Sind Sie sicher, dass Sie die Bewerbung jetzt abschicken möchten?</p>
        <div class="confirm-toast-buttons">
          <button class="confirm-btn" @click="confirmSubmission">Ja</button>
          <button class="cancel-btn" @click="cancelSubmission">Abbrechen</button>
        </div>
      </div>
    </div>


    <section class="hero-career">
      <h1>Karriere bei Pflegedienst Gallus Pflegedienst e.K.</h1>
      <p>Wir benötigen Verstärkung, trete jetzt unserem Team bei! </p>
    </section>

    <!--APPLICATION-PROCESS-->

    <!--OFFERS-->
    <section class="career-jobs">

      <h2>Offene Stellen</h2>
      <h4>Klicke auf die passende Stelle, um dich direkt zu bewerben.</h4>
      <div class="job-card" @click="openForm('pflegefachkraft')">
        <h3>Pflegefachkraft (m/w/d)</h3>
        <p>Wir suchen aktuell eine erfahrene Pflegefachkraft zur Verstärkung unseres Teams.</p>
      </div>
      <div class="job-card" @click="openForm('ausbildung')">
        <h3>Ausbildung zur Pflegefachkraft</h3>
        <p>Start der Ausbildung ab nächstem Jahr – bewirb dich initiativ.</p>
      </div>
    </section>

    <!-- FORM -->
    <section class="career-form">
      <div class="popup-overlay" v-show="showForm" @click.self="closeForm">
        <div class="popup-box">
          <button class="close-btn" @click="closeForm">×</button>
          <h2>Jetzt Bewerben</h2>
          <form @submit.prevent="submitForm">
            <label>
              Name:
              <input type="text" v-model="form.name" required/>
            </label>

            <label>
              Vorname:
              <input type="text" v-model="form.forename" required/>
            </label>

            <label>
              E-Mail:
              <input type="email" v-model="form.email" required/>
            </label>

            <label>
              Telefonnummer:
              <input type="text" v-model="form.number" required/>
            </label>

            <label>
              Position:
              <select v-model="form.position" required>
                <option value="pflegefachkraft">Pflegefachkraft</option>
                <option value="ausbildung">Ausbildung zur Pflegefachkraft</option>
              </select>
            </label>

            <label>
              Lebenslauf (PDF):
              <div class="file-upload-wrapper">
    <span class="upload-btn">
      {{ form.resume ? form.resume.name : "PDF auswählen…" }}
    </span>
                <input type="file" @change="handleFileUpload($event, 'resume')" accept=".pdf"/>
              </div>
            </label>

            <label>
              Anschreiben (PDF):
              <div class="file-upload-wrapper">
              <span class="upload-btn">
                {{ form.cover ? form.cover.name : "PDF auswählen…" }}
              </span>
                <input type="file" @change="handleFileUpload($event, 'cover')" accept=".pdf"/>
              </div>
            </label>

            <label class="checkbox-label">
              <input
                  type="checkbox"
                  v-model="form.data"
                  required
              />

              <span class="custom-checkbox"></span>

              <span class="checkbox-text">
              Ich stimme der Verarbeitung meiner Daten gemäß
              <a href="/datenschutz" target="_blank">Datenschutzerklärung</a>
              zu.
              </span>

            </label>

            <button type="submit">Bewerbung absenden</button>
          </form>
        </div>
      </div>
    </section>
  </div>


</template>

<style scoped>

</style>